import {
  Autocomplete,
  Box,
  Dialog,
  Drawer,
  IconButton,
  InputAdornment,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { theme } from "../../styles/theme";
import { TextFieldMA } from "../../styles/styledComponents";
// import OrganisationBadge from "../statusBadge/organisationBadge";
import { Cancel } from "@mui/icons-material";
import { ButtonCustom } from "../button";
import { font } from "../../styles/font";
import {
  adminEmployeeAccess,
  demoIncrease,
  discountUpdate,
  followUp,
  organizationList,
  updateAdminEmployee,
  updateAssignee,
} from "../../api/controllers/adminController";
import { HttpStatusCode } from "axios";
import dayjs from "dayjs";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
import { ApplicationContext } from "../../context/application_ctx";
import { TableReadOnly } from "../../pages/userOnBoarding/tableReadOnly";
// import LicenceTypeChip from "../statusBadge/licenceTypeChip";
import { OrganisationDashboard } from "../../pages/organisationDashboard";
import { NavigationDock } from "../navigationDock";
// import PeopleIcon from "@mui/icons-material/People";
import {
  FieldHeading,
  FieldValue,
  UserProfileDetail,
} from "../../pages/userProfileDetail";
import { Header } from "../header";
import { Licence } from "../../pages/licence";
import { OrganisationProfileDetail } from "../../pages/organisationProfileDetail";
import { RepresentativeDetail } from "../../pages/representativeDetails";
import BusinessIcon from "@mui/icons-material/Business";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AdminDashboardTable({
  organisationList,
  setOrganisationList,
  adminList,
}) {
  const {
    setProfileSnack,
    setError,
    setEmployeesList,
    setFilteredList,
    setLicenceBatchList,
    employeesList,
    // filteredList,
    licenceBatchList,
    setHeader,
    setPaymentList,
    activeTab,
    setActiveTab,
    dashboardQuery,
    setAuditList,
    setAssignDetails,
    setProfileDetails,
    setDockMenu,
    dockMenu
  } = useContext(ApplicationContext);
  console.log(adminList, "adminList");
  let color = [
    { colorName: "Green", code: "#73D373" },
    { colorName: "Amber", code: "#FFBF00" },
    { colorName: "Red", code: "red" },
  ];
  const adminQuery = useMediaQuery("(max-width:667px)");
  const [detailsDialog, setDetailsDialog] = useState({});
  const [noOfEmployees, setNoOfEmployees] = useState(
    detailsDialog?.numberOfEmployees || 20
  );
  const [noOfEmployeesChange, setNoOfEmployeesChange] = useState(
    detailsDialog?.numberOfEmployees || 20
  );
  const [confirmModal, setConfirmModal] = useState(false);
  const [followModal, setFollowModal] = useState(false);
  const [employeeModal, setEmployeeModal] = useState(false);
  const [accessModal, setAccessModal] = useState(false);
  const [followComment, setFollowComment] = useState(null);
  const [representModal, setRepresentModal] = useState(false);
  const [licenceModal, setLicenceModal] = useState(false);
  const [discountModal, setDiscountModal] = useState(false);
  const [loaderState, setloaderState] = useState(false);
  const [tableModal, setTableModal] = useState(false);
  const [noOfLicence, setNoOfLicence] = useState(null);
  const [noOfDays, setNoOfDays] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [colorSelection, setColorSelection] = useState(
    color.filter((data) => data?.code === detailsDialog?.colorCode)[0]
  );

  let navItems = [
    {
      label: " Dashboard",
    },
    {
      label: "Employee onboarding ",
    },
    {
      label: "Licence",
    },
    {
      label: "User Profile",
    },
    {
      label: "Company Profile",
    },
  ];
  const [selectAdmin, setSelectAdmin] = useState(
    adminList?.filter(
      (data) => data?.name === detailsDialog?.representativeName
    )[0]
  );
  console.log(
    color.filter((data) => data?.code === detailsDialog?.colorCode)[0],
    "selection"
  );
  let date = new Date(detailsDialog?.createdAt)?.toDateString().split(" ");

  const handleDetails = (users) => {
    setDetailsDialog(users);
    setConfirmModal(true);
  };
  const handleTable = (users, dialog) => {
    if (!dialog) {
      setActiveTab(0);
      setTableModal(true);
    }
    setDetailsDialog(users);
    setEmployeesList(users?.employees);
    setFilteredList(users?.employees);
    setLicenceBatchList(users?.licenseBatch);
    setPaymentList(users?.licenseBatch);
    setAuditList(users?.auditLogs);
    setAssignDetails(users);
    setProfileDetails(users);
  };

  console.log(licenceBatchList, employeesList, "listtt");
  const handleDetailsFollowUp = (users) => {
    console.log(users, "dddd");
    setDetailsDialog(users);
    setFollowModal(true);
  };

  const handleDetailsEmployee = (users) => {
    console.log(users, "dddd");
    setDetailsDialog(users);
    setEmployeeModal(true);
  };

  const handleDetailsAccess = (users) => {
    console.log(users, "dddd");
    setDetailsDialog(users);
    setAccessModal(true);
  };

  const handleMARepresentAccess = (users) => {
    console.log(users, "dddd");
    setDetailsDialog(users);
    setRepresentModal(true);
  };

  const handleLicenceModal = (users, dialog) => {
    console.log(users, "dddd");
    setDetailsDialog(users);
    setLicenceModal(true);
  };
  const handleDiscountModal = (users) => {
    console.log(users, "dddd");
    setDetailsDialog(users);
    setDiscount(users?.discount);
    setDiscountModal(true);
  };

  const handleFollowUp = async () => {
    try {
      let response = await followUp({
        organizationId: detailsDialog._id,
        text: followComment,
      });
      if (response.status === HttpStatusCode.Ok) {
        setFollowModal(false);
        let response = await organizationList();
        console.log(response, "list");
        setOrganisationList(response.data);
        handleClose();
      }
      console.log(response, "followupResponse");
    } catch (error) {
      console.log(error);
    }
  };

  const handleEmployee = async () => {
    try {
      let response = await updateAdminEmployee({
        organizationId: detailsDialog._id,
        licenseCount: noOfEmployees,
      });
      if (response.status === HttpStatusCode.Ok) {
        setEmployeeModal(false);
        let response = await organizationList();
        console.log(response, "list");
        setOrganisationList(response.data);
      }
      console.log(response, "followupResponse");
    } catch (error) {
      console.log(error);
    }
  };

  const handleAccess = async () => {
    try {
      let response = await adminEmployeeAccess({
        organizationId: detailsDialog._id,
      });
      if (response.status === HttpStatusCode.Ok) {
        setAccessModal(false);
        let response = await organizationList();
        console.log(response, "list");
        setOrganisationList(response.data);
      }
      console.log(response, "followupResponse");
    } catch (error) {
      console.log(error);
    }
  };

  const handleDemoIncrease = async () => {
    setLicenceModal(true);

    try {
      let response = await demoIncrease({
        organizationId: detailsDialog._id,
        additionalLicenses: noOfLicence,
        additionalDays: noOfDays,
      });
      console.log(response, "followupResponse");
      if (response.status === HttpStatusCode.Ok) {
        setError(response.data.message);
        setProfileSnack(true);
        // setLicenceModal(false);
        handleClose(true);
        let responseReload = await organizationList();
        console.log(responseReload, "list");
        setOrganisationList(responseReload.data);
        handleTable(
          responseReload.data.filter(
            (data) => data?._id === detailsDialog?._id
          )[0],
          true
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const appleDiscount = async () => {
    setloaderState(true);
    try {
      let response = await discountUpdate({
        organizationId: detailsDialog._id,
        discountRate: discount ?? detailsDialog?.discount,
      });
      console.log(response, "discountResp");
      if (response.status === HttpStatusCode.Ok) {
        setloaderState(false);
        setError(response.data.message);
        setProfileSnack(true);
        handleClose(true);
        let responseReload = await organizationList();
        console.log(responseReload, "list");
        setOrganisationList(responseReload.data);
        handleTable(
          responseReload.data.filter(
            (data) => data?._id === detailsDialog?._id
          )[0],
          true
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  console.log(detailsDialog, "checkdetails");
  const handleAssignee = async () => {
    console.log(detailsDialog, "checkdetails");
    if (
      (detailsDialog?.representativeName && detailsDialog?.colorCode) ||
      (colorSelection && selectAdmin)
    )
      try {
        let response = await updateAssignee({
          organizationId: detailsDialog?._id,
          representativeId:
            selectAdmin?._id ??
            adminList?.filter(
              (data) => data?.name === detailsDialog?.representativeName
            )[0]?._id,
          colorCode:
            colorSelection?.code ??
            color?.filter((data) => data?.code === detailsDialog?.colorCode)[0]
              ?.code,
        });
        if (response.status === HttpStatusCode.Ok) {
          setRepresentModal(false);
          let response = await organizationList();
          console.log(response, "list");
          setOrganisationList(response.data);
          setDetailsDialog({});
          setColorSelection(null);
          setSelectAdmin(null);
        }
        console.log(response, "followupResponse");
      } catch (error) {
        console.log(error);
      }
  };
  const handleClose = (dialog) => {
    if (licenceBatchList?.length === 0) {
      setDetailsDialog({});
    }
    setFollowModal(false);
    setLicenceModal(false);
    setNoOfLicence(null);
    setNoOfDays(null);
    setFollowComment(null);
    setColorSelection(null);
    setSelectAdmin(null);
    setDiscountModal(false);
    setDiscount(null);
    // setTableModal(false);
    setHeader(null);
  };
  console.log(discount, activeTab, "ddddd");
  return (
    <Box width="100%" display="flex" overflow="auto" flex='1' maxHeight={'calc(100vh - 215px)'}>
      <TableContainer
        style={{
          borderRadius: "8px",
          border: `1px solid ${theme.bgBorder}`,
          minHeight: "420px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Table className="tableEmployees" size="small" stickyHeader>
          <TableHead sx={{ height: "52px" }}>
            <TableCell></TableCell>
            <TableCell>Company</TableCell>
            {/* <TableCell> Phone</TableCell> */}
            {/* <TableCell> Email</TableCell> */}
            <TableCell>Total Users</TableCell>
            {/* <TableCell> Valid up to</TableCell> */}
            {/* <TableCell> Employees</TableCell> */}
            {/* <TableCell> Status</TableCell> */}
            {/* <TableCell> Licence Type</TableCell> */}
            {/* <TableCell> Contacted</TableCell> */}
            {/* <TableCell> Query </TableCell> */}
            <TableCell> Discount </TableCell>
            <TableCell> Total Yearly Revenue </TableCell>
            <TableCell> Onboarding Date</TableCell>
            {/* <TableCell> Licence</TableCell> */}
            {/* <TableCell>Expiration</TableCell> */}
            {/* <TableCell>Followed By</TableCell> */}
            {/* <TableCell>Followed Comment</TableCell> */}
            {/* <TableCell align="center">MA Action</TableCell> */}
            {/* <TableCell align="center">Representatives</TableCell> */}
            <TableCell align="center">Company View</TableCell>
          </TableHead>
          <TableBody>
            {organisationList?.map((data, i) => {
              return (
                <>
                  <EmployeeDataTableRow
                    data={data}
                    i={i}
                    handleDetails={handleDetails}
                    handleTable={handleTable}
                    handleDetailsFollowUp={handleDetailsFollowUp}
                    handleDetailsEmployee={handleDetailsEmployee}
                    handleDetailsAccess={handleDetailsAccess}
                    setRepresentModal={setRepresentModal}
                    handleMARepresentAccess={handleMARepresentAccess}
                    handleLicenceModal={handleLicenceModal}
                    handleDiscountModal={handleDiscountModal}
                  />
                </>
              );
            })}
          </TableBody>
        </Table>
        {organisationList?.length === 0 ? (
          <Box
            display="flex"
            width="100%"
            alignItems="center"
            justifyContent="center"
            height="100%"
            flexDirection="column"
            flex="1"
          >
            <Box
              display="flex"
              px={3}
              backgroundColor={theme.col_2_alpha}
              height="80px"
              borderRadius="13px"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                color={theme.col_2}
                textAlign="center"
                fontSize={font.size.fs_5}
                fontWeight="bold"
              >
                No company found
              </Typography>
            </Box>
          </Box>
        ) : (
          ""
        )}
      </TableContainer>

      {/* dialog */}
      <Dialog
        open={confirmModal}
        maxWidth={"100%"}
        maxheight={"100%"}
        sx={{
          "& .MuiDialog-paper": {
            minWidth: "50%",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            padding="12px 0px 20px 0px"
            width="90%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                Company Details
              </Typography>
              <IconButton onClick={() => setConfirmModal(false)}>
                <Cancel sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>

            <Box
              display="flex"
              gap={"18px"}
              flexDirection={adminQuery ? "column" : "row"}
            >
              <Box
                display="flex"
                flexDirection="column"
                // justifyContent="center"
                width="100%"
                gap="5px"
                borderRight={`2px solid ${theme.col_2_alpha}`}
              >
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                  display="flex"
                  gap="7px"
                >
                  <FieldHeading>Name</FieldHeading>
                  <FieldValue>
                    {detailsDialog?.companyName ?? "........"}
                  </FieldValue>
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                  display="flex"
                  gap="7px"
                >
                  <FieldHeading>Email</FieldHeading>
                  <FieldValue>{detailsDialog?.email ?? "........"}</FieldValue>
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                  display="flex"
                  gap="7px"
                >
                  <FieldHeading>Verified</FieldHeading>
                  <FieldValue>
                    {detailsDialog?.isProfileVerified ? "Yes" : "No"}
                  </FieldValue>
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                >
                  Date of Creation : {date[2]} {date[1]} {date[3]}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                >
                  Licence : {detailsDialog?.licenseCount ?? "........"}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                >
                  Number of Employees :{" "}
                  {detailsDialog?.numberOfEmployees ?? "........"}
                </Typography>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                // justifyContent="center"
                width="100%"
                gap={1}
              >
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                >
                  Company Address :{" "}
                  {detailsDialog?.companyAddress ?? "........"}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                >
                  Company Description :{" "}
                  {detailsDialog?.companyDescription ?? "........"}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                >
                  Company Keywords :{" "}
                  {detailsDialog?.companyKeywords ?? "........"}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                >
                  Company Registration Number :{" "}
                  {detailsDialog?.companyRegistrationNumber ?? "........"}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                >
                  Company URL : {detailsDialog?.companyUrl ?? "........"}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                >
                  legalStatus : {detailsDialog?.legalStatus ?? "........"}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  textAlign="justify"
                  color={theme.col_2}
                >
                  VAT Registration Number :{" "}
                  {detailsDialog?.vatRegistrationNumber ?? "........"}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  color={theme.col_2}
                >
                  License Purchase Date :{" "}
                  {dayjs(detailsDialog?.licensePurchaseDate).format(
                    "DD MMMM YYYY"
                  ) ?? "........"}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  color={theme.col_2}
                >
                  License Expiration Date :{" "}
                  {dayjs(detailsDialog?.licenseExpirationDate).format(
                    "DD MMMM YYYY"
                  ) ?? "........"}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={followModal}
        // fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "409px",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            padding="12px 0px 20px 0px"
            width="90%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                MA Action
              </Typography>
              <IconButton onClick={handleClose}>
                <Cancel sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>
            {detailsDialog?.followUpNotes?.length !== 0 ? (
              <Box
                display="flex"
                //   justifyContent=""
                flexDirection="column"
                width="100%"
                gap="12px"
                alignItems="flex-start"
                maxHeight="450px"
                overflow="auto"
              >
                {detailsDialog?.followUpNotes?.map((notes) => {
                  return (
                    <Box
                      //   display="flex"
                      //   justifyContent="center"
                      width="100%"
                      borderRadius="9px"
                      px={2}
                      py={1}
                      maxWidth="350px"
                      //   alignItems="center"
                      backgroundColor={theme.col_14_alpha}
                    >
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_3}
                        fontWeight="bold"
                        color={theme.col_2}
                        whiteSpace="nowrap"
                        // flex="1"
                      >
                        {notes?.adminName?.split(" ")[0]}
                      </Typography>
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_3}
                        fontWeight="bold"
                        color={theme.col_3}
                        sx={{ wordBreak: "break-all" }}
                        display="flex"
                        gap="9px"
                      >
                        {notes.note}
                      </Typography>
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        // fontWeight="bold"
                        textAlign="end"
                        color={theme.col_2}
                        // flex="1"
                      >
                        {dayjs(notes?.createdAt).format(
                          "DD MMMM YYYY , HH:MM A"
                        )}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            ) : (
              <></>
            )}
            <TextFieldMA
              size="small"
              //   required={isFollowedUp}
              error={
                followComment === null
                  ? false
                  : followComment === ""
                  ? true
                  : false
              }
              helperText={
                followComment === null
                  ? ""
                  : followComment === ""
                  ? "Comment is required"
                  : ""
              }
              // multiline
              // rows={5}
              // value={noOfEmployeesChange}
              // onBlur={(e) =>
              //     e.target.value < 0 ? 0 : setNoOfEmployees(e.target.value)
              // }
              onChange={(e) => setFollowComment(e.target.value)}
              fullWidth
              label="Comment"
            />
            <ButtonCustom
              borderRadius="40px"
              onClick={handleFollowUp}
              fullWidth={true}
              disabled={!followComment}
              // width="50%"
              height="35px"
              // borderRadius="42px"
              // size="large"
              background={theme.col_3}
              backgroundRipple={theme.col_2}
              focusColor={theme.col_1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              typography={
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  // fontWeight="bold"
                  color={!followComment ? theme.col_6 : theme.col_4}
                >
                  MA Action
                </Typography>
              }
            />
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={employeeModal}
        // fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "409px",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            padding="12px 0px 20px 0px"
            width="90%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                Update Licence Number
              </Typography>
              <IconButton onClick={() => setEmployeeModal(false)}>
                <Cancel sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>

            <TextFieldMA
              size="small"
              required
              type="number"
              error={
                noOfEmployees === null
                  ? false
                  : noOfEmployees === ""
                  ? true
                  : false
              }
              helperText={
                noOfEmployees === null
                  ? ""
                  : noOfEmployees === ""
                  ? "No of employees is required"
                  : ""
              }
              value={noOfEmployeesChange}
              onBlur={(e) =>
                e.target.value < 0 ? 0 : setNoOfEmployees(e.target.value)
              }
              onChange={(e) =>
                e.target.value < 0 ? 0 : setNoOfEmployeesChange(e.target.value)
              }
              fullWidth
              label="Number of Employees"
            />
            <ButtonCustom
              borderRadius="40px"
              onClick={handleEmployee}
              fullWidth={true}
              disabled={false}
              // width="50%"
              height="35px"
              // borderRadius="42px"
              // size="large"
              background={theme.col_3}
              backgroundRipple={theme.col_2}
              focusColor={theme.col_1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              typography={
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  // fontWeight="bold"
                  color={theme.col_4}
                >
                  confirm
                </Typography>
              }
            />
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={representModal}
        // fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "409px",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            padding="12px 0px 20px 0px"
            width="90%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                MA Representatives
              </Typography>
              <IconButton onClick={() => setRepresentModal(false)}>
                <Cancel sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>

            <Box width="100%" display="flex" flexDirection="column">
              <Box
                width="100%"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                gap="12px"
              >
                <Autocomplete
                  id="country-select-demo"
                  // sx={{ width: 300 }}
                  // fullWidth
                  sx={{ width: "100%" }}
                  value={
                    colorSelection ||
                    color.filter(
                      (data) => data?.code === detailsDialog?.colorCode
                    )[0]
                  }
                  // getOptionSelected={(option, value) => option.phone === value.phone}
                  // valuek
                  disableClearable
                  getOptionLabel={(option) => option?.colorName}
                  getOptionValue={(option) => option?.colorName}
                  isOptionEqualToValue={(option, value) =>
                    option?.colorName === value?.colorName
                  }
                  onChange={(event, val) => {
                    setColorSelection(val);
                  }}
                  // componentsProps={{
                  //   popper: { style: { width: "400px" } },
                  // }}
                  size="small"
                  options={color}
                  autoHighlight
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      sx={{
                        "& > img": { mr: 2, flexShrink: 0 },
                        display: "flex",
                        alignItems: "center",
                        gap: "17px",
                      }}
                      {...props}
                    >
                      <Box
                        width="35px"
                        height="35px"
                        borderRadius="40px"
                        backgroundColor={option.code}
                      ></Box>
                      {option.colorName}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextFieldMA
                      name="password"
                      autoComplete="off"
                      {...params}
                      label="Select Color"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password", // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
                <Autocomplete
                  id="country-select-demo"
                  // sx={{ width: 300 }}
                  // fullWidth
                  sx={{ width: "100%" }}
                  value={
                    selectAdmin ||
                    adminList?.filter(
                      (data) => data?.name === detailsDialog?.representativeName
                    )[0]
                  }
                  // getOptionSelected={(option, value) => option.phone === value.phone}
                  // valuek
                  disableClearable
                  getOptionLabel={(option) => option?.name}
                  getOptionValue={(option) => option?.name}
                  isOptionEqualToValue={(option, value) =>
                    option?.name === value?.name
                  }
                  onChange={(event, val) => {
                    setSelectAdmin(val);
                  }}
                  // componentsProps={{
                  //   popper: { style: { width: "400px" } },
                  // }}
                  size="small"
                  options={adminList}
                  autoHighlight
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      sx={{
                        "& > img": { mr: 2, flexShrink: 0 },
                        display: "flex",
                        alignItems: "center",
                        gap: "17px",
                      }}
                      {...props}
                    >
                      {option.name}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextFieldMA
                      {...params}
                      name="password"
                      autoComplete="off"
                      label="Select Representative"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password", // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
                {/* <TextFieldMA
                    size='small'
                    
                    // {...params}
                    label="Representative"
                    inputProps={{
                      autoComplete: "new-password", // disable autocomplete and autofill
                    }}
                  /> */}
              </Box>
            </Box>
            <ButtonCustom
              borderRadius="40px"
              onClick={handleAssignee}
              fullWidth={true}
              // disabled={!selectAdmin || !colorSelection}
              // width="50%"
              height="35px"
              // borderRadius="42px"
              // size="large"
              background={theme.col_3}
              backgroundRipple={theme.col_2}
              focusColor={theme.col_1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              typography={
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  // fontWeight="bold"
                  color={theme.col_4}
                  // color={!selectAdmin || !colorSelection ? theme.col_6 :theme.col_4}
                >
                  confirm
                </Typography>
              }
            />
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={accessModal}
        // fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "409px",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            padding="12px 0px 20px 0px"
            width="90%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                Company Access manage
              </Typography>
              <IconButton onClick={() => setAccessModal(false)}>
                <Cancel sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>
            <Typography
              fontFamily={font.family.fm_2}
              textTransform={"capitalize"}
              fontSize={font.size.fs_3}
              fontWeight="bold"
              // textAlign='center'
              color={theme.col_2}
              flex="1"
            >
              Please confirm to{" "}
              {detailsDialog.isOrganizationBanned ? "Unrevoke" : "Revoke"}{" "}
              current company
            </Typography>
            <Box
              display="flex"
              flexDirection="column"
              // justifyContent="center"
              width="100%"
              gap="5px"
              borderTop={`2px solid ${theme.col_2_alpha}`}
              pt={2}
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Name : {detailsDialog?.companyName ?? "........"}
              </Typography>
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Email : {detailsDialog?.email ?? "........"}
              </Typography>
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Verified : {detailsDialog?.isProfileVerified ? "Yes" : "No"}
              </Typography>
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Date of Creation : {date[2]} {date[1]} {date[3]}
              </Typography>
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Licence : {detailsDialog?.licenseCount ?? "........"}
              </Typography>
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Number of Employees :{" "}
                {detailsDialog?.numberOfEmployees ?? "........"}
              </Typography>
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Trial : {detailsDialog?.isOnDemo ? "Yes" : "No" ?? "........"}
              </Typography>
            </Box>
            <ButtonCustom
              borderRadius="40px"
              onClick={handleAccess}
              fullWidth={true}
              disabled={false}
              // width="50%"
              height="35px"
              // borderRadius="42px"
              // size="large"
              background={theme.col_3}
              backgroundRipple={theme.col_2}
              focusColor={theme.col_1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              typography={
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  // fontWeight="bold"
                  color={theme.col_4}
                >
                  {detailsDialog.isOrganizationBanned ? "Unrevoke" : "Revoke"}
                </Typography>
              }
            />
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={licenceModal}
        // fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "409px",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            padding="12px 0px 20px 0px"
            width="90%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                Trial Licence Extend
              </Typography>
              <IconButton onClick={handleClose}>
                <Cancel sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>

            <TextFieldMA
              size="small"
              type="number"
              //   required={isFollowedUp}
              error={
                noOfLicence === null ? false : noOfLicence === "" ? true : false
              }
              helperText={
                noOfLicence === null
                  ? ""
                  : noOfLicence === ""
                  ? "No of licence is required"
                  : ""
              }
              value={noOfLicence < 0 ? 0 : noOfLicence}
              // multiline
              // rows={5}
              // value={noOfEmployeesChange}
              // onBlur={(e) =>
              //     e.target.value < 0 ? 0 : setNoOfEmployees(e.target.value)
              // }
              onChange={(e) =>
                setNoOfLicence(e.target.value < 0 ? 0 : e.target.value)
              }
              fullWidth
              label="No of licence"
            />
            <TextFieldMA
              size="small"
              type="number"
              //   required={isFollowedUp}
              error={noOfDays === null ? false : noOfDays === "" ? true : false}
              helperText={
                noOfDays === null
                  ? ""
                  : noOfDays === ""
                  ? "No of days are required"
                  : ""
              }
              value={noOfDays < 0 ? 0 : noOfDays}
              // multiline
              // rows={5}
              // value={noOfEmployeesChange}
              // onBlur={(e) =>
              //     e.target.value < 0 ? 0 : setNoOfEmployees(e.target.value)
              // }
              onChange={(e) =>
                setNoOfDays(e.target.value < 0 ? 0 : e.target.value)
              }
              fullWidth
              label="No of days"
            />
            <ButtonCustom
              borderRadius="40px"
              onClick={handleDemoIncrease}
              fullWidth={true}
              disabled={!noOfDays || !noOfLicence}
              // width="50%"
              height="35px"
              // borderRadius="42px"
              // size="large"
              background={theme.col_3}
              backgroundRipple={theme.col_2}
              focusColor={theme.col_1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              typography={
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  // fontWeight="bold"
                  color={!noOfDays || !noOfLicence ? theme.col_6 : theme.col_4}
                >
                  Extend
                </Typography>
              }
            />
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={discountModal}
        // fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "439px",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            padding="12px 0px 20px 0px"
            width="90%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                Discount Percent
              </Typography>
              <IconButton onClick={handleClose}>
                <Cancel sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>
            <Typography
              fontFamily={font.family.fm_2}
              // textTransform={"capitalize"}
              fontSize={font.size.fs_3}
              fontWeight="bold"
              // textAlign='center'
              color={theme.col_2}
              flex="1"
            >
              Please enter Disocunt percent for the organization
            </Typography>
            <Box
              display="flex"
              flexDirection="column"
              // justifyContent="center"
              width="100%"
              gap="5px"
              pt={2}
            >
              <TextFieldMA
                value={discount ?? detailsDialog?.discount}
                type="number"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">%</InputAdornment>
                  ),
                }}
                onChange={(e) =>
                  setDiscount(
                    e.target.value < 0
                      ? 0
                      : e.target.value >= 100
                      ? 100
                      : e.target.value
                  )
                }
                size="small"
                name="Discount"
                autoComplete="off"
                label="Enter Discount Percent"
                inputProps={{
                  autoComplete: "new-password", // disable autocomplete and autofill
                }}
              />
            </Box>
            <ButtonCustom
              borderRadius="40px"
              onClick={appleDiscount}
              disabled={loaderState}
              loaderState={loaderState}
              fullWidth={true}
              // width="50%"
              height="35px"
              // borderRadius="42px"
              // size="large"
              background={theme.col_3}
              backgroundRipple={theme.col_2}
              focusColor={theme.col_1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              typography={
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  // fontWeight="bold"
                  color={theme.col_4}
                >
                  Apply
                </Typography>
              }
            />
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={tableModal}
        fullWidth
        fullScreen
        TransitionComponent={Transition}
        // maxWidth={"100%"}
        // maxheight={"100%"}
        sx={{ ".MuiDialog-paper": { overflow: "hidden" } }}
        // PaperProps={{
        //   style: {
        //     maxHeight: "100%",
        //     width: "409px",
        //   },
        // }}
      >
        <Box display="flex" gap={2} width="100%" backgroundColor={theme.col_7}>

          {dashboardQuery ? <Drawer sx={{zIndex:1500}} open={dockMenu} onClose={() => setDockMenu(false)}>
        <NavigationDock
        dialog={true}
        admin={true}
          setDockMenu={setDockMenu}
          dashboardQuery={dashboardQuery}
          navItems={navItems}
        />
      </Drawer> :  <NavigationDock dialog={true} navItems={navItems} admin={true} />}
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            padding="12px 0px 20px 0px"
            // width="80%"
            height="100vh"
            flex="1"
            alignItems="center"
            // backgroundColor={theme.col_4}
            overflow="auto"
          >
            <Box
              display="flex"
              justifyContent="center"
              width="93%"
              alignItems="center"
              position="sticky"
              top={0}
              zIndex={10}
            >
              <Header
                admin={false}
                dialog={true}
                setDockMenu={setDockMenu}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                dashboardQuery={dashboardQuery}
              />
              <IconButton onClick={() => setTableModal(false)}>
                <Cancel sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>

            <Box
              display="flex"
              flexDirection={"column"}
              gap={2}
              width="93%"
              flex="1"
            >
              <ActiveDialogTab
                handleLicenceModal={handleLicenceModal}
                handleDiscountModal={handleDiscountModal}
                detailsDialog={detailsDialog}
                activeTab={activeTab}
              />
            </Box>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}

const ActiveDialogTab = ({
  activeTab,
  handleDiscountModal,
  detailsDialog,
  handleLicenceModal,
}) => {
  switch (activeTab) {
    case 0:
      return (
        <OrganisationDashboard
          handleLicenceModal={handleLicenceModal}
          handleDiscountModal={handleDiscountModal}
          detailsDialog={detailsDialog}
          admin={true}
        />
      );
    case 1:
      return <TableReadOnly admin={true} />;
    case 2:
      return <Licence admin={true} />;
    case 3:
      return <UserProfileDetail admin={true} />;
    case 4:
      return <OrganisationProfileDetail admin={true} />;
    case 5:
      return <RepresentativeDetail admin={true} />;
    default:
      return (
        <OrganisationDashboard
          handleLicenceModal={handleLicenceModal}
          handleDiscountModal={handleDiscountModal}
          detailsDialog={detailsDialog}
          admin={true}
        />
      );
  }
};

const EmployeeDataTableRow = ({
  data,
  i,
  handleDetails,
  handleDetailsFollowUp,
  handleDetailsEmployee,
  handleDetailsAccess,
  setRepresentModal,
  handleAssignee,
  handleMARepresentAccess,
  handleLicenceModal,
  handleDiscountModal,
  handleTable,
}) => {
  console.log(data, "data");
  const dateFormat1 = dayjs(data?.licensePurchaseDate).format("YYYY-MM-DD");
  const dateFormate2 = dayjs(data?.licenseExpirationDate).format("YYYY-MM-DD");
  //   console.log(date1?.diff(date2,'days'),'diff')
  const date1 = dayjs(dateFormat1);
  const date2 = dayjs(dateFormate2);
  console.log(date2?.diff(date1, "days"), "diff");
  //   console.log(date2,'diff')
  return (
    <>
      <TableRow
        // onClick={() => handleTable(data)}
        sx={{
          height: "52px",
          // backgroundColor: rowSelecter.includes(data)
          //   ? theme.col_3_alpha
          //   : theme.col_4,
        }}
      >
        <TableCell>{i + 1}</TableCell>

        <TableCell size="small" colSpan="1" align="left">
          <Typography fontSize={font.size.fs_3} fontFamily={font.family.fm_3}>
            {data.companyName ?? "........"}
          </Typography>
        </TableCell>

        {/* <TableCell size="small" colSpan="1" align="left">
          <Typography fontSize={font.size.fs_3} fontFamily={font.family.fm_3}>
            {data.phoneNumber ?? "........"}
          </Typography>
        </TableCell> */}
        {/* <TableCell size="small" colSpan="1" align="left">
          <Typography fontSize={font.size.fs_3} fontFamily={font.family.fm_3}>
            {data.email ?? "........"}
          </Typography>
        </TableCell> */}
        <TableCell size="small" colSpan="1" align="left">
          <Typography fontSize={font.size.fs_3} fontFamily={font.family.fm_3}>
            {data?.licenseBatch?.length === 0 ? 'Pending Verification' : 
              data?.licenseBatch.map((data) => data.totalLicenses)
              .reduce((a, b) => a + b, 0)}
          </Typography>
        </TableCell>

        {/* <TableCell size="small" colSpan="1" align="left">
          <Typography
            fontSize={font.size.fs_3}
            whiteSpace="nowrap"
            fontFamily={font.family.fm_3}
          >
            {dayjs(data.licenseExpirationDate).format("DD MMMM YYYY") ??
              "........"}
          </Typography>
        </TableCell> */}
        {/* <TableCell size="small" colSpan="1" align="left">
          <Typography fontSize={font.size.fs_3} fontFamily={font.family.fm_3}>
            {data.numberOfEmployees ?? "........"}
          </Typography>
        </TableCell> */}
        {/* <TableCell size="small" colSpan="1" align="left">
          <OrganisationBadge admin={true} status={data.isOrganizationBanned} />
        </TableCell> */}
        {/* <TableCell size="small" colSpan="1" align="left">
          {data?.licenseBatch?.length === 0 ? (
            "Pending verification"
          ) : (
            <Typography display="flex" alignItems="center" gap="8px">
              <Typography display="flex" flexDirection="column" gap="8px">
                <>
                  <LicenceTypeChip data={data?.licenseBatch[0]} type="Trial" />

                  {data.licenseBatch.length > 1 ? (
                    <LicenceTypeChip
                      data={data?.licenseBatch[data?.licenseBatch?.length - 1]}
                      type="Standard"
                    />
                  ) : (
                    <></>
                  )}
                </>
              </Typography>

              <Tooltip
                title={
                  <Box display="flex" flexDirection="column" gap="6px">
                    <Typography fontWeight="bold" fontSize={font.size.fs_4}>
                      Trial licence Extend
                    </Typography>
                  </Box>
                }
              >
                <AddCircleIcon
                  sx={{ color: theme.col_3, cursor: "pointer" }}
                  onClick={() => handleLicenceModal(data)}
                />
              </Tooltip>
            </Typography>
          )}
        </TableCell> */}
        {/* <TableCell size="small" colSpan="1" align="left">
          <Typography
            fontSize={font.size.fs_3}
            textTransform="capitalize"
            fontFamily={font.family.fm_3}
          >
            {data?.contacted === "" || !data?.contacted
              ? "........"
              : data?.contacted}
          </Typography>
        </TableCell> */}
        {/* <TableCell size="small" colSpan="1" align="left">
          <Tooltip
            disableHoverListener={data?.message === "" || !data?.message}
            title={
              <Box
                width="200px"
                display="flex"
                flexDirection="column"
                gap="6px"
              >
                <Typography fontWeight="bold" fontSize={font.size.fs_4}>
                  {data?.message === "" || !data?.message
                    ? "No query yet"
                    : data?.message}
                </Typography>
              </Box>
            }
          >
            <Typography fontSize={font.size.fs_3} fontFamily={font.family.fm_3}>
              {data?.message === "" || !data?.message
                ? "........"
                : data?.message.slice(0, 41)}
              {data.message.length > 41 ? "..." : ""}
            </Typography>
          </Tooltip>
        </TableCell> */}

        <TableCell
          onClick={() => handleDiscountModal(data)}
          size="small"
          colSpan="1"
          align="left"
        >
          <Tooltip
            title={
              <Box display="flex" flexDirection="column" gap="6px">
                <Typography fontWeight="bold" fontSize={font.size.fs_4}>
                  {"Discount"}
                </Typography>
              </Box>
            }
          >
            <Typography
            width='fit-content'
              sx={{
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
              fontSize={font.size.fs_3}
              fontFamily={font.family.fm_3}
            >
              {data?.discount}%
            </Typography>
          </Tooltip>
        </TableCell>
        <TableCell size="small" colSpan="1" align="left">
          <Typography fontSize={font.size.fs_3} fontFamily={font.family.fm_3}>
            &pound;
            {Math.round(data.licenseBatch
              .map((data) => data.paidAmount)
              .reduce((a, b) => a + b, 0))}
          </Typography>
        </TableCell>

        <TableCell size="small" colSpan="1" align="left">
          <Typography fontSize={font.size.fs_3} fontFamily={font.family.fm_3}>
            { data?.employees?.length !== 0 ? dayjs(data?.employees[0]?.createdAt).format("DD MMMM YYYY") : "......"}
          </Typography>
        </TableCell>
        {/* <TableCell size="small" colSpan="1" align="left" >

                    <td ><Typography noWrap="wrap" width="100%">{data.licenseCount}</Typography></td>

                </TableCell> */}

        {/* <TableCell size="small" colSpan="1" align="left">
          <Typography fontSize={font.size.fs_3} fontFamily={font.family.fm_3}>
            {data.numberOfEmployees ?? "........"}
          </Typography>
        </TableCell> */}
        {/* <TableCell size="small" colSpan="1" align="left" >

                    <td ><Typography noWrap="wrap" width="100%">abcd user</Typography></td>

                </TableCell>
                <TableCell size="small" colSpan="1" align="left" >

                    <td ><Typography noWrap="wrap" width="100%">handled</Typography></td>

                </TableCell> */}
        {/* <TableCell
          size="small"
          sx={{
            cursor: "pointer",
          }}
          onClick={() => handleDetailsFollowUp(data)}
          align="left"
        >
          <Tooltip
            title={
              <Box
                // width="250px"
                display="flex"
                flexDirection="column"
                gap="6px"
              >
                <Typography fontWeight="bold" fontSize={font.size.fs_4}>
                  Click to see replies
                </Typography>
              </Box>
            }
          >
            <Typography
              fontSize={font.size.fs_3}
              fontFamily={font.family.fm_3}
              display="flex"
              alignItems="flex-start"
              fontWeight="bold"
              gap="8px"
              color={theme.col_6}
              sx={{ "&:hover": { textDecoration: "underline" } }}
              whiteSpace="nowrap"
            >
              Last reply by
            </Typography>
            <Typography
              fontSize={font.size.fs_3}
              fontFamily={font.family.fm_3}
              display="flex"
              // justifyContent="center"
              gap="8px"
              color={theme.col_6}
              sx={{ "&:hover": { textDecoration: "underline" } }}
            >
              {data?.followUpNotes[data?.followUpNotes?.length - 1]
                ?.adminName ?? "None"}
            </Typography>
          </Tooltip>
         
        </TableCell> */}
        {/* <IconButtonMA
              onClick={() => handleDetailsFollowUp(data)}
              size="small"
            >
              <Tooltip title="Follow Up">
                <BookmarkIcon />
              </Tooltip>
            </IconButtonMA> */}
        {/* <IconButtonMA
              onClick={() => handleDetailsEmployee(data)}
              size="small"
            >
              <Tooltip title="Number of Employees">
                <BadgeIcon />
              </Tooltip>
            </IconButtonMA> */}
        {/* <IconButtonMA
              onClick={() => handleDetailsAccess(data)}
              size="small"
            >
              {" "}
              <Tooltip title="Access management">
                <LibraryAddCheckIcon />
              </Tooltip>
            </IconButtonMA> */}
        {/* <IconButtonMA onClick={() => handleDetails(data)}>
              <Tooltip title="Details">
                <Info />
              </Tooltip>
            </IconButtonMA> */}
        {/* <TableCell
          sx={{
            cursor: "pointer",
            // "&:hover": { background: theme.col_14_alpha },
            backgroundColor: data?.colorCode,
          }}
          onClick={() => handleMARepresentAccess(data)}
          size="small"
          colSpan="1"
          align="center"
        >
          <Tooltip
            title={
              <Box
                // width="250px"
                display="flex"
                flexDirection="column"
                gap="6px"
              >
                <Typography fontWeight="bold" fontSize={font.size.fs_4}>
                  Click to change representative
                </Typography>
              </Box>
            }
          >
            <Typography fontSize={font.size.fs_3} fontFamily={font.family.fm_3}>
              {data?.representativeName}
            </Typography>
          </Tooltip>
        </TableCell> */}
        <TableCell size="small" colSpan="1" align="center">
          <Tooltip
            title={
              <Box display="flex" flexDirection="column" gap="6px">
                <Typography fontWeight="bold" fontSize={font.size.fs_4}>
                  {data?.licenseBatch?.length === 0
                    ? "Pending Verification"
                    : "Company View"}
                </Typography>
              </Box>
            }
          >
            <BusinessIcon
              onClick={() => handleTable(data)}
              sx={{
                fontSize:'30px',
                color:
                  data?.licenseBatch?.length === 0 ? theme.col_5 : theme.col_3,
                cursor: "pointer",
                pointerEvents:
                  data?.licenseBatch?.length === 0 ? "none" : "all",
              }}
              disabled
            />
          </Tooltip>
        </TableCell>

        {/* <TableCell size="small" colSpan="1" align="center" style={{ minWidth: "80px", maxWidth: "80px" }}>
                    <td>
                        <OrganisationBadge status={data.licenseStatus} />
                    </td>
                </TableCell> */}
      </TableRow>
    </>
  );
};
